import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	discoverAutomationMenuItemLabel: {
		id: 'software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label',
		defaultMessage: 'Discover automation',
		description: 'A label for the popup menu item for Discover automation deep-link',
	},
	manageAutomationMenuItemLabel: {
		id: 'software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label',
		defaultMessage: 'Manage automation',
		description: 'A label for the popup menu item for Manage automation deep-link',
	},
	createAutomationMenuItemLabel: {
		id: 'software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label',
		defaultMessage: 'Create automation',
		description: 'A label for the popup menu item for Create automation deep-link',
	},
	auditLogAutomationMenuItemLabel: {
		id: 'software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label',
		defaultMessage: 'Audit log',
		description: 'A label for the popup menu item for Audit Log automation deep-link',
	},
});
